module.exports = __webpack_public_path__ + "media/mypage/images/default/nophoto-76b281d5e0e0771eb4df087bf7f629df.jpg";